import { useState } from "react";

export function Instruction({ item, setDoneItems }: any) {
  const [isChecked, setIsChecked] = useState(false);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
    if (e.target.checked) {
      // @ts-ignore
      setDoneItems((p) => [...p, item]);
    } else {
      // @ts-ignore
      setDoneItems((p) => p.slice(1));
    }
  };

  return (
    <div className="p-3 bg-white rounded-xl border-[0.5px] border-[#E4E2E3]">
      <div className="flex items-center gap-x-3 pb-2">
        <input
          className="w-4 h-4 accent-black"
          type="checkbox"
          id=""
          name="topping"
          value="Paneer"
          checked={isChecked}
          onChange={handleOnChange}
        />
        <span className="font-semibold text-[#434343]">
          Step {item?.stepNumber}&nbsp;:&nbsp;{item?.stageTitle}
        </span>
      </div>
      <p
        className={`${
          isChecked ? "line-through" : ""
        } font-normal text-[#656364] text-base`}
      >
        {item?.instruction}
      </p>
    </div>
  );
}
